(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("angular"), require("moment"), require("urijs"));
	else if(typeof define === 'function' && define.amd)
		define("infocertFeconIsac", ["_", "angular", "moment", "urijs"], factory);
	else if(typeof exports === 'object')
		exports["infocertFeconIsac"] = factory(require("lodash"), require("angular"), require("moment"), require("urijs"));
	else
		root["infocertFeconIsac"] = factory(root["_"], root["angular"], root["moment"], root["urijs"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_23__, __WEBPACK_EXTERNAL_MODULE_24__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _feconIsac = __webpack_require__(9);

var _feconIsac2 = _interopRequireDefault(_feconIsac);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import feconIsacDefaultConfiguration from './fecon-isac__configuration';

exports.default = angular.module('infocert.js.fecon.fecon-isac', [_feconIsac2.default]
//feconIsacDefaultConfiguration
).name;
module.exports = exports['default'];

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _index2.default;
module.exports = exports['default'];

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var config = {
  'supportedIsacLanguages': ['it', 'en'], // as specified by isac-angular wiki
  'defaultIsacLanguage': 'it', // used when current application language does'nt match an isac supported language

  'authenticationRequired.stateDataPropertyName': 'authRequired',

  'sessionExpiredHttpInterceptor.exclusionHeader': {
    name: 'X-FeCon-Isac-Request',
    value: 'true'
  },
  'sessionExpiredHttpInterceptor.additionalExclusionHeaders': [{
    name: 'X-Requested-For',
    value: 'auth'
  }],

  'credentialsRecovery.sendEmail.delegateApiCallToProductIntegration': false,
  'credentialsRecovery.sendEmail.productApiPath': '/product-api/force-email'
};

var feconIsacConfigProvider = function () {
  function feconIsacConfigProvider() {
    _classCallCheck(this, feconIsacConfigProvider);
  }

  _createClass(feconIsacConfigProvider, [{
    key: 'has',


    // provider
    value: function has(key) {
      return _lodash2.default.has(config, key);
    }
  }, {
    key: 'get',
    value: function get(key) {
      return config[key];
    }
  }, {
    key: 'set',
    value: function set(key, val) {
      config[key] = val;
    }
  }, {
    key: '$get',
    value: function $get() {
      var self = this;

      // public
      return {
        has: self.has,
        get: self.get,
        set: self.set
      };
    }
  }]);

  return feconIsacConfigProvider;
}();

exports.default = feconIsacConfigProvider;
module.exports = exports['default'];

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _urijs = __webpack_require__(24);

var _urijs2 = _interopRequireDefault(_urijs);

var _moment = __webpack_require__(23);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var antiLoop = 0,
    maxAntiloop = 20,
    antiLoopResetAtFun = 'login';
var pageLogics = window.feconIsacPageLogicHistory = [];

var debugEnabled = false;

var cache = {
  isAuthenticated: false,
  hasSecurityInfo: false
};

var FeconIsacFacade = function () {
  FeconIsacFacade.$inject = ["$state", "$injector", "$translate", "feconIsacConfig", "FeconIsacRestClient", "FeconIsacModalPage", "FeconIsacModalLoginFlow", "$timeout", "$q", "$log"];
  function FeconIsacFacade($state, $injector, $translate, feconIsacConfig, FeconIsacRestClient, FeconIsacModalPage, FeconIsacModalLoginFlow, $timeout, $q, $log) {
    'ngInject';

    _classCallCheck(this, FeconIsacFacade);

    this.logger = $log.getInstance('FeconIsacFacade');
    this.$state = $state;
    this.$translate = $translate;

    this.feconIsacConfig = feconIsacConfig;
    this.FeconIsacRestClient = FeconIsacRestClient;
    this.FeconIsacModalPage = FeconIsacModalPage;
    this.FeconIsacModalLoginFlow = FeconIsacModalLoginFlow;

    this.$timeout = $timeout;
    this.$q = $q;

    this._debugEnabled(feconIsacConfig.get('debug'));
    this.integrationDelegate = __provideIntegrationDelegate(this.logger, $injector, feconIsacConfig.get('integrationDelegate'));
  }

  _createClass(FeconIsacFacade, [{
    key: 'syncProductIsAuthenticated',
    value: function syncProductIsAuthenticated() {
      return cache.isAuthenticated;
    }
  }, {
    key: 'syncHasSecurityInfo',
    value: function syncHasSecurityInfo() {
      return cache.hasSecurityInfo;
    }

    /**
     * Restituisce un oggetto avente una property k:v corrispondente a nome:valore dell'header preposto a non interferire con il sessionExpiredInterceptor
     */

  }, {
    key: 'getFeconIsacTransparentHttpHeaders',
    value: function getFeconIsacTransparentHttpHeaders() {
      var exclusionHeader = this.feconIsacConfig.get('sessionExpiredHttpInterceptor.exclusionHeader');
      var additionalHttpHeaders = {};
      additionalHttpHeaders[exclusionHeader.name] = exclusionHeader.value || 1;
      return additionalHttpHeaders;
    }

    /**
     * Deve determinare se esiste una sessione di lavoro valida.
     * @note deve effettuare sempre la chiamata api, non può usare la cache.
     */

  }, {
    key: 'asyncCheckAuthentication',
    value: function asyncCheckAuthentication() {
      var _this = this;

      this.logger.log('asyncCheckAuthentication()');

      var additionalHeaders = this.getFeconIsacTransparentHttpHeaders();

      // temp: using directly ISAC
      return this.FeconIsacRestClient.isAuthenticated({ additionalHeaders: additionalHeaders }).then(function () {
        var self = _this;

        return _this.integrationDelegate.asyncCheckProductAuthentication({ additionalHeaders: additionalHeaders }).then(function () {
          cache.isAuthenticated = true;
          return self.$q.resolve({ authenticated: true });
        });
      }, function () {
        cache.isAuthenticated = false;
        cache.hasSecurityInfo = false;
        return _this.$q.reject({ authenticated: false });
      });
    }

    /**
     * Deve verificare se per la sessione corrente sono impostate le info sicurezza.
     * @note deve effettuare sempre la chiamata api, non può usare la cache.
     */

  }, {
    key: 'asyncCheckSecurityInfo',
    value: function asyncCheckSecurityInfo() {
      var _this2 = this;

      var additionalHeaders = this.getFeconIsacTransparentHttpHeaders();

      return this.$q(function (resolve, reject) {
        _this2.FeconIsacRestClient.getSecurityInfo({ additionalHeaders: additionalHeaders }).then(function () {
          cache.hasSecurityInfo = true;
          resolve({ securityInfo: true });
        }, function (e) {
          // se non ci sono info sicurezza, lo status code è 402
          cache.hasSecurityInfo = false;
          reject({ securityInfo: false, error: e });
        });
      });
    }

    /**
     * Effettua il logout verso isac e verso il back-end di prodotto.
     *
     * TODO valutare se mostrare modale di attesa o un layer semiopaco durante l'operazione
     * TODO gestire meglio l'alert brutale del caso di fallimento
     * TODO considerare il fallimento del logout verso il prodotto (ora sto usando finally)
     */

  }, {
    key: 'logout',
    value: function logout(opts) {
      var _this3 = this;

      var facade = this;
      opts = _lodash2.default.isObject(opts) ? opts : {};

      var optExecuteFinalUrlRedirect = !opts.preventRedirectToLogoutUrl;

      var additionalHeaders = this.getFeconIsacTransparentHttpHeaders();

      return this.FeconIsacRestClient.logout({ additionalHeaders: additionalHeaders }).then(function () {
        return facade.integrationDelegate.asyncDestroyProductSession({ additionalHeaders: additionalHeaders }).finally(function () {
          cache.isAuthenticated = false;
          cache.hasSecurityInfo = false;

          if (optExecuteFinalUrlRedirect) {
            var targetUrl = facade._getLogoutUrl();
            facade.logger.log('logout() full page reload to: ' + targetUrl);
            window.location.href = targetUrl;
          }
        });
      }, function (reason) {
        // TODO gestire meglio
        alert('There was an error logging out. Please try again');

        return _this3.$q.reject(reason);
      });
    }

    /**
     * Chiama l'api di back-end di prodotto per effettuare un invio mail contenente l'url pubblico dell'applicazione ed il queryParam recoveryToken
     *
     * @note usato pubblicamente da feconIsacFrameController
     * @returns Promise
     */

  }, {
    key: 'asyncExecuteSendEmailForCredentialsRecovery',
    value: function asyncExecuteSendEmailForCredentialsRecovery(event) {
      this.logger.log('asyncExecuteSendEmailForCredentialsRecovery(event) event:', event);

      var additionalHeaders = this.getFeconIsacTransparentHttpHeaders();
      return this.integrationDelegate.asyncExecuteSendEmailForCredentialsRecovery({ additionalHeaders: additionalHeaders });
    }

    // ------  -------   ------  -------   ------  -------


  }, {
    key: 'provideLoggedIn',
    value: function provideLoggedIn() {
      this.$state.go(this.getTargetMainAuthenticatedState());
    }
  }, {
    key: 'getTargetLoginState',
    value: function getTargetLoginState() {
      //return 'login';
      return this.integrationDelegate.getLoginState();
    }

    /**
     * Entry point per avviare un flusso di autenticazione
     *
     * @since 1.1.0
     * @param opts
     * @return {*}
     */

  }, {
    key: 'provideAuthentication',
    value: function provideAuthentication() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var initiator = !_lodash2.default.isNil(opts.initiator) ? '' + opts.initiator : ''; // toString() or empty string ''
      var $transition = opts.transition || null;

      var fromState = {
        name: $transition ? $transition.from().name : '',
        params: $transition ? $transition.params().from : {}
      };
      var toState = {
        name: $transition ? $transition.to().name : '',
        params: $transition ? $transition.params("to") : {}
      };

      var transition = { fromState: fromState, toState: toState };

      this.logger.log('provideAuthentication() - fromState, toState:', fromState, toState);

      return this.provideLogin({
        initiator: initiator,
        transition: transition
      });
    }
  }, {
    key: 'provideLogin',


    /**
     * Richiede di iniziare il flusso di autenticazione di default (basato sul cambio di stati applicativo)
     *
     * @since 1.1.0
     * @param opts
     * @return {*}
     */
    value: function provideLogin() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var targetLoginState = _createNormalizedRouterState(this.getTargetLoginState());
      if (!targetLoginState || !targetLoginState.name) {
        this.logger.info('provideLogin() skip redirect to non-valid targetLoginState.', targetLoginState);
        return false; // false interrompe l'ingresso allo stato autenticato che ha scatenato il flusso (ui-router transition)
      }

      Object.assign(targetLoginState.options, { reload: true });

      this.logger.log('provideLogin() redirecting to state ' + targetLoginState.name, targetLoginState);
      return this.$state.go(targetLoginState.name, targetLoginState.params, targetLoginState.options);
    }

    /**
     * Provide a modal login flow returning a promise representing result of the entire flow
     * @since 1.1.0
     * @return {*|Promise<any>|Promise.<TResult>}
     */

  }, {
    key: 'provideModalLogin',
    value: function provideModalLogin() {
      return this.FeconIsacModalLoginFlow.provideModalLogin(this);
    }
  }, {
    key: 'getTargetMainAuthenticatedState',
    value: function getTargetMainAuthenticatedState() {
      //return 'main.authenticated';
      return this.integrationDelegate.getLoggedInState();
    }
  }, {
    key: '_getCompatibleIsacLanguageKey',
    value: function _getCompatibleIsacLanguageKey(key) {
      key = '' + (key || ''); // assure string

      // se esiste una fun apposita, delego a lei la conversione
      if (_lodash2.default.isFunction(this.integrationDelegate.getCompatibleIsacLanguageKey)) {
        key = this.integrationDelegate.getCompatibleIsacLanguageKey(key);
      } else {
        // isac utilizza chiavi semplici 'it', 'en'.
        // Lo standard è it_IT, en_EN, en_US, ..: utilizzo il token a sinistra perché + generico

        var keyParts = key.split(/[_-]/);
        key = keyParts && keyParts.length ? keyParts[0] : '';
      }

      key = _lodash2.default.toLower(key);

      if (_lodash2.default.includes(this.feconIsacConfig.get('supportedIsacLanguages') || [], key)) {
        return key;
      } else {
        return this.feconIsacConfig.get('defaultIsacLanguage');
      }
    }

    // @note: publicly used by FeconIsacFrameController

  }, {
    key: 'getCurrentCompatibleIsacLanguage',
    value: function getCurrentCompatibleIsacLanguage() {
      return this._getCompatibleIsacLanguageKey(this.$translate.use());
    }
  }, {
    key: 'getIsacCustomizationObject',
    value: function getIsacCustomizationObject(opts) {
      var customizationObject = this.integrationDelegate.getIsacCustomizationObject(opts);
      if (!_lodash2.default.isObject(customizationObject)) {
        customizationObject = {};
      }

      delete customizationObject.redirect; // rimuovo l'eventuale property "redirect" perché la utilizzo internamente
      customizationObject.language = this.getCurrentCompatibleIsacLanguage();

      return customizationObject;
    }
  }, {
    key: 'getIsacRecoveryPage_forceEmailOptions',
    value: function getIsacRecoveryPage_forceEmailOptions(opts) {
      return {
        isApiCallDelegatedToProduct: this.feconIsacConfig.get('credentialsRecovery.sendEmail.delegateApiCallToProductIntegration') == true,
        apiPath: this.feconIsacConfig.get('credentialsRecovery.sendEmail.productApiPath')
      };
    }
  }, {
    key: 'openAccountModal',
    value: function openAccountModal() {
      var isacPageLogic = this.pageLogic({ funName: 'account', mode: 'modal' });
      return this.FeconIsacModalPage.open({ isacPageLogic: isacPageLogic });
    }
  }, {
    key: 'sessionExpired',
    value: function sessionExpired() {
      this.logger.log('sessionExpired() invoked');
      var targetUrl = this._getLogoutUrl();
      this.logger.log('sessionExpired() full page reload to: ' + targetUrl);
      window.location.href = targetUrl;
    }
  }, {
    key: 'provideSecurityInfo',
    value: function provideSecurityInfo() {
      var isacPageLogic = this.pageLogic({ funName: 'secInfo', mode: 'modal' });
      return this.FeconIsacModalPage.open({ isacPageLogic: isacPageLogic });
    }

    // ------  -------   ------  -------   ------  -------


  }, {
    key: '_getLogoutUrl',
    value: function _getLogoutUrl() {
      var logoutURI = void 0;
      var logoutUrl = void 0;

      var integrationProvidedLogoutUrl = null;
      if (_lodash2.default.isFunction(this.integrationDelegate.getTargetLogoutUrl)) {
        integrationProvidedLogoutUrl = this.integrationDelegate.getTargetLogoutUrl();
      }

      if (integrationProvidedLogoutUrl) {
        logoutURI = (0, _urijs2.default)(integrationProvidedLogoutUrl);
      } else {
        logoutURI = (0, _urijs2.default)(window.location.href);
        // rimuovo il path client-side (ovvero l'hash #!/path) in modo che l'app riparta da / (così il router utilizzerà il defaultState definito in router.config.js)
        logoutURI.hash('');
      }

      var currentURI = (0, _urijs2.default)(window.location.href);
      if (logoutURI.hostname() == currentURI.hostname()) {
        this.logger.log('logout url has same hostname as current. Replacing with current query-params..');

        var queryMap = currentURI.query(true);

        queryMap['ts'] = (0, _moment2.default)().unix();

        logoutURI.query(queryMap);
      }

      logoutUrl = logoutURI.toString();
      this.logger.log('_getLogoutUrl() final logoutUrl: ' + logoutUrl);

      return logoutUrl;
    }

    // ------


  }, {
    key: '_debugEnabled',
    value: function _debugEnabled(enabled) {
      if (!_lodash2.default.isUndefined(enabled)) {
        debugEnabled = !!enabled;
      }
      return debugEnabled;
    }

    /**
     *
     * @param spec {{ funName: string, mode: string }}
     * @returns {{getIsacPage: getIsacPage, handleRedirect: (function(*=))}}
     */

  }, {
    key: 'pageLogic',
    value: function pageLogic(spec) {
      var _this4 = this;

      if (!spec || !spec.funName) {
        throw new Error('providePageLogic(spec) expected spec object with a valid "funName" property. got: ' + (typeof spec === 'undefined' ? 'undefined' : _typeof(spec)) + ' (' + JSON.stringify(spec) + ')');
      }

      var funName = spec.funName,
          funParams = spec.funParams || {},
          mode = spec.mode,
          // page or modal
      flowName = spec.flowName || 'default',
          // expected 'default' or 'loginModalFlow'
      options = _lodash2.default.cloneDeep(spec.options || {}) // options to merge into pageSpec.options
      ;

      var customizationObject = this.getIsacCustomizationObject(_lodash2.default.cloneDeep({ funName: funName, funParams: funParams, mode: mode, flowName: flowName, options: options }));
      var forceEmail_options = this.getIsacRecoveryPage_forceEmailOptions(_lodash2.default.cloneDeep({ funName: funName, funParams: funParams, mode: mode, flowName: flowName, options: options }));

      // anti-loop
      pageLogics.push(Object.assign({}, spec, cache, { antiLoop: antiLoop, maxAntiloop: maxAntiloop }));
      if (antiLoopResetAtFun == funName) {
        antiLoop = 0;
      }
      if (antiLoop++ > maxAntiloop) {
        throw new Error('pageLogic() - antiLoop reached');
      }
      // anti-loop  /end

      var debugEnabled = this._debugEnabled();

      return {
        getIsacPage: function getIsacPage() {
          var pageSpec = getIsacPageSpec(funName, funParams);

          pageSpec.customizationObject = customizationObject;
          pageSpec.forceEmail_options = forceEmail_options;
          pageSpec.options = _lodash2.default.merge({}, pageSpec.options, options);

          if (debugEnabled) {
            pageSpec.options.debug = true;
          }

          return pageSpec;
        },
        handleRedirect: function handleRedirect(event) {
          //alert(event.payload.target);
          return _this4.provideFun(event, {
            parent: { funName: funName, funParams: funParams, mode: mode, flowName: flowName, options: options }
          });
        }
      };
    }
  }, {
    key: 'provideFun',
    value: function provideFun(event, parentInfo) {

      var funName = event.payload.target;
      var funParams = event.payload.funParams;
      var mode = pageFunMode(funName);
      var parentMode = parentInfo.parent.mode;

      var isacPageLogic = this.pageLogic({ funName: funName, funParams: funParams, mode: mode });

      switch (mode) {
        case 'modal':
          return this.FeconIsacModalPage.open({ isacPageLogic: isacPageLogic });

        case 'page':
          return {
            newIsacPage: isacPageLogic.getIsacPage()
          };

        case 'full-redirect':

        case 'state-redirect':
          var targetState = this._pageStateRedirect(funName);
          if (targetState) {
            this.$state.go(targetState, { replace: true });
          }
          return {
            done: 'handled by state-redirect'
          };

        default:
          throw new Error('Unhandled page mode ' + mode);
      }
    }
  }, {
    key: '_pageStateRedirect',
    value: function _pageStateRedirect(pageName) {
      this.logger.log('pageStateRedirect() - page:' + pageName);

      switch (pageName) {
        case 'loggedIn':
          return this.provideLoggedIn();

      }

      this.logger.error('pageStateRedirect() unhandled pageName "' + pageName + '"');
    }
  }]);

  return FeconIsacFacade;
}();

exports.default = FeconIsacFacade;


function pageFunMode(pageName) {
  switch (pageName) {

    case 'login':
    case 'noInfoSec':

      return 'full-redirect';

    case 'loggedIn':

      return 'state-redirect';

    case 'pwGone':
    case 'pwForgot':
    case 'pwLock':
    case 'secInfo':
    case 'twoFactor':
    case 'account':

      return 'modal';

    case 'forceEmail':
      throw new Error('TODO: pageFunMode "' + pageName + '" unmanaged. THIS IS A BUG');

    default:
      console.error('pageFunMode() unhandled pageName "' + pageName + '"');
  }
}

function getIsacPageSpec(funName, funParams) {
  switch (funName) {

    case 'login':
      return {
        funName: 'login',
        funTitle: 'FECON_ISAC.FUN_LOGIN.TITLE',
        injection: 'injection_login.js',
        funParams: funParams,
        options: {
          userCanSkip: true
        }
      };

    // NOTA: pwLock e pwForgot internamente innescano "lo stesso giro" pur usando una injection diversa

    case 'pwGone':
      // pwGone: quando la pass è scaduta si va in pwGone   -> ovvero serve injection_renewPassword
      return {
        funName: 'pwGone',
        funTitle: 'FECON_ISAC.FUN_PWGONE.TITLE',
        injection: 'injection_renewPassword.js',
        funParams: funParams,
        options: {
          userCanSkip: false
        }
      };

    case 'pwForgot':
      // pwForgot: quando l'utente ha dimenticato la pass e vuole recuperarla si va in pwForgot   -> ovvero serve injection_renewPassword
      return {
        funName: 'pwForgot',
        funTitle: 'FECON_ISAC.FUN_PWFORGOT.TITLE',
        injection: 'injection_recovery.js',
        funParams: funParams,
        options: {
          userCanSkip: true
        }
      };

    case 'pwLock':
      // dopo n tentativi di login la password viene bloccata e si va in pwLock
      return {
        funName: 'pwLock',
        funTitle: 'FECON_ISAC.FUN_PWLOCK.TITLE',
        injection: 'injection_recovery.js',
        funParams: funParams,
        options: {
          userCanSkip: false
        }
      };

    case 'forceEmail':
      // forceEmail: **** CHECK NON è COSì **** --->  è utilizzato per effettuare la chiamata al product-api per farli inviare l'email col link di recupero
      return {
        funName: 'forceEmail',
        funTitle: 'FECON_ISAC.FUN_FORCEEMAIL.TITLE',
        injection: 'injection_force.js',
        funParams: funParams,
        options: {
          userCanSkip: false
        }
      };

    case 'secInfo':
      // securityInfo: quando fai login e non hai le info sicurezza si va in secutiryInfo per inserirle
      // ci si va anche se ricarico la pagina da autenticato e faccio il check via isac-client delle info sicurezza ma sono mancanti
      return {
        funName: 'secInfo',
        funTitle: 'FECON_ISAC.FUN_SECINFO.TITLE',
        injection: 'injection_securityInfo.js',
        funParams: funParams,
        options: {
          userCanSkip: false
        }
      };

    case 'noInfoSec':
      // noInfoSec: se vuoi recuperare la pass e non hai le infoSicurezza impostate -> si va in noInfoSec
      // Nota: se mancano le info di sicurezza non si ti fa procedere col recupero via email o sms.. ti manda direttamente in noInfoSec
      // *********      WHAT TO DO??     *************
      // TODO: gestire
      break;

    case 'loggedIn':
      // loggedIn: la teoria vorrebbe che si atterri dopo il login (ed eventuali stati intermedi) con successo
      // -> ma isac-angular lo invoca ad-cazzum:
      // se ho:   password scaduta:
      //                login -> pwGone -> loggedIn
      // se ho:   password scaduta + mancano le info sicurezza
      //                login -> pwGone -> loggedIn -(fecon-isac precondition)-> secInfo -> loggedIn
      break;

    case 'twoFactor':
      // twoFactor: l'utente si è autenticato, isac non può sapere se l'applicazione specifica richiede il secondo livello (auth 2 fattori)
      // è product-api che decide (la get session del product-api deve gestire un codice di ritorno specifico ed il front-end deve innescare questa pagina)
      // injection: 'injection_twoFactor.js';
      throw new Error('twoFactor unimplemented yet :(');

    case 'account':
      // account è innescata volontariamente dall'utente autenticato per editare il proprio profilo (cambiare le info sicurezza e cambiare la password)
      return {
        funName: 'account',
        funTitle: 'FECON_ISAC.FUN_ACCOUNT.TITLE',
        injection: 'injection_account.js',
        funParams: funParams,
        options: {
          userCanSkip: true
        }
      };

  }

  console.error('getPageInjection() unhandled pageName "' + funName + '"');
}

/**
 * Normalizza lo stato in ingresso (stringa o oggetto) restituendo un oggetto con properties name, params e options
 *
 * @param _state { string | { name:string, params:{} }}
 * @return {{ name:string, params:{}, options:{} }}
 * @private
 */
function _createNormalizedRouterState(_state) {
  var state = _lodash2.default.cloneDeep(_state);

  if (_lodash2.default.isString(state)) {
    state = {
      name: state,
      params: {},
      options: {}
    };
  } else {
    state.params = state.params || {};
    state.options = state.options || {};
  }

  return state;
}

// utils

function __provideIntegrationDelegate(logger, $injector, integrationDelegateServiceName) {
  if (!_lodash2.default.trim(integrationDelegateServiceName)) {
    throw new Error('FeconIsac integration delegate was not set.\n  \n   @see example:\n   feconIsacConfigProvider.set(\'integrationDelegate\', \'ProductFeconIsacIntegration\');\n\n');
  }

  try {
    return $injector.get(integrationDelegateServiceName);
  } catch (e) {
    throw new Error('FeconIsac integration delegate service named "' + integrationDelegateServiceName + '" was not found.', e);
  }
}
module.exports = exports['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var antiLoop = 0,
    maxAntiloop = 20,
    antiLoopResetAtFun = 'login';
var modalPageLogics = window.feconIsacModalLoginFlowPageLogicHistory = [];

var debugEnabled = false;

var FeconIsacModalLoginFlow = function () {
  FeconIsacModalLoginFlow.$inject = ["$timeout", "$q", "$log", "FeconIsacModalPage"];
  function FeconIsacModalLoginFlow($timeout, $q, $log, FeconIsacModalPage) {
    'ngInject';

    _classCallCheck(this, FeconIsacModalLoginFlow);

    this.logger = $log.getInstance('FeconIsacModalLoginFlow');
    this.$timeout = $timeout;
    this.$q = $q;
    this.FeconIsacModalPage = FeconIsacModalPage;

    this.flowDeferred = null;
  }

  /**
   * start: login
   *
   *  managed redirect: pwGone, pwForgot, pwLock, secInfo
   *  managed <neutral> redirect: loggedIn      ->  deve verificare via api se la sessione esiste e se sono presenti le info sicurezza e comportarsi di conseguenza
   *
   * TODO un-managed redirect: noInfoSec, twoFactor -> non ancora gestite neanche per il flusso standard
   *
   * @return {*|Promise<any>|Promise.<TResult>}
   */


  _createClass(FeconIsacModalLoginFlow, [{
    key: 'provideModalLogin',
    value: function provideModalLogin(feconIsacFacade) {
      var _this = this;

      if (!feconIsacFacade) {
        throw new Error('Missing or invalid feconIsacFacade', feconIsacFacade);
      }
      if (this.flowDeferred) {
        throw new Error('Another flow is already in progress');
      }

      this.logger.log('provideModalLogin() initializing flow ..');

      this.feconIsacFacade = feconIsacFacade;
      this.flowDeferred = this.$q.defer();

      var pageLogic = this._provideModalPageLogic({ funName: 'login' });
      this.__provideModalFun({ pageLogic: pageLogic });

      return this.flowDeferred.promise.then(function (result) {
        _this.flowDeferred = null;
        _this.logger.log('Resolving flow successfully..');
        return _this.$q.resolve(result);
      }, function (reason) {
        _this.flowDeferred = null;
        _this.logger.log('Rejecting flow. reason:', reason);
        return _this.$q.reject(reason);
      });
    }
  }, {
    key: '__provideModalFun',
    value: function __provideModalFun(_ref) {
      var _this2 = this;

      var pageLogic = _ref.pageLogic;

      this.logger.log('__provideModalFun()  pageLogic:', pageLogic);

      var isacPageLogic = $pageLogicRedirectHandlerDecorator(pageLogic, function (e, $fn) {
        return _this2._$delegatedRedirectHandler(e, $fn, pageLogic);
      });

      this.FeconIsacModalPage.open({ isacPageLogic: isacPageLogic }).then(function (result) {
        _this2._evaluateModalPageResult(result, isacPageLogic);
      }, function (reason) {
        _this2._evaluateModalPageRejection(reason, isacPageLogic);
      });
    }
  }, {
    key: '_evaluateModalPageResult',
    value: function _evaluateModalPageResult(result, isacPageLogic) {
      this.logger.log('_evaluateModalPageResult()\n  result:', result, '\n  isacPageLogic:', isacPageLogic);

      // la modale viene RISOLTA da feconModalPage DOPO aver gestito la handleRedirect
      // per cui non è necessario effettuare alcuna operazione in questo punto
    }
  }, {
    key: '_evaluateModalPageRejection',
    value: function _evaluateModalPageRejection(reason, isacPageLogic) {
      this.logger.log('_evaluateModalPageRejection()\n  reason:', reason, '\n  isacPageLogic:', isacPageLogic);

      // Nel caso in cui l'utente naviga avanti/indietro nel browser (o il codice applicativo per strani comportamenti effettua un cambio di stato)
      // isac-client-bundle effettua la reject di tutte le modali aperte fornendo una reason '__DISMISSED_BY_STATE_CHANGE'
      // In questo caso rigetto l'intero flusso
      if (reason === '__DISMISSED_BY_STATE_CHANGE') {
        this.flowDeferred.reject(reason);
        return;
      }

      var fromFunName = isacPageLogic.getIsacPage().funName;
      this.logger.log('_evaluateModalPageRejection()  source fun:', fromFunName);

      switch (fromFunName) {
        // L'utente può chiudere la modale di login a piacimento terminando il flusso
        case 'login':
          this.flowDeferred.reject(reason);
          break;

        // Dalla modale di login, l'utente può decidere di recuperare la password (cliccando "non riesci ad accedere?")
        // che (oltre a risolvere la login via handleRedirect) apre la fun pwForgot
        // l'utente può chiudere la modale pwForgot a piacimento
        case 'pwForgot':
          /*
          // -> POSSIBLE OPTION: lo faccio tornare alla modale di login (dato che può chiudere anche quella a piacimento)
          let pageLogic = this._provideModalPageLogic({ funName: 'login' });
          this.__provideModalFun({ pageLogic });
          */

          // -> termino il flusso
          this.flowDeferred.reject(reason);
          break;

        default:
          var error = new Error('_evaluateModalPageRejection() Unexpected modal rejection: this may be a bug, please report that at the InfoCert Dev Team');
          this.logger.error(error);
      }
    }
  }, {
    key: '_$delegatedRedirectHandler',
    value: function _$delegatedRedirectHandler(event, originalHandlerFn, pageLogic) {
      var sourceIsacPage = pageLogic.getIsacPage();
      var fromFunName = sourceIsacPage.funName;
      var requiredTargetFunName = _lodash2.default.get(event, 'payload.target');
      this.logger.log('_$delegatedRedirectHandler()\n  event:', event, '\n  required target:', requiredTargetFunName, '\n  source fun:', fromFunName);

      switch (requiredTargetFunName) {
        case 'loggedIn':
          this.logger.log('_$delegatedRedirectHandler()   -> loggedIn  - checking real session state..');

          // in alcuni casi (oscuri) isac richiede redirect a loggedIn anche se mancano le info di sicurezza, controllo..
          // nel frattempo mantengo aperta e bloccata la modale corrente restituendo { waitBeforeExit: Promise }
          return {
            waitBeforeExit: this._redirectHandler_loggedIn(event)
          };

        default:
          this.logger.log('_$delegatedRedirectHandler()   using __provideModalFun ..');
          this.__provideModalFun({
            pageLogic: this._provideModalPageLogicForEvent(event)
          });

          return;
      }
    }
  }, {
    key: '_redirectHandler_loggedIn',
    value: function _redirectHandler_loggedIn(event) {
      var _this3 = this;

      this.logger.log('_redirectHandler_loggedIn() - checking session state ..');

      return this.feconIsacFacade.asyncCheckAuthentication().then(function () {
        return _this3.feconIsacFacade.asyncCheckSecurityInfo();
      }).then(function () {
        _this3.logger.log('_redirectHandler_loggedIn() - session OK');
        _this3.flowDeferred.resolve();
      }, function (reason) {
        _this3.logger.log('_redirectHandler_loggedIn() - session KO. reason:', reason);

        // La risposta è popolata da FeconIsacDelegate:
        //    se la reject è di  asyncCheckAuthentication()   ho reason.authenticated = false
        //    se la reject è di  asyncCheckSecurityInfo()     ho reason.hasSecurityInfo = false

        var requiredFunName = null;
        if (reason.authenticated === false) requiredFunName = 'login';
        if (reason.hasSecurityInfo === false) requiredFunName = 'secInfo';

        if (requiredFunName) {
          var pageLogic = _this3._provideModalPageLogic({ funName: requiredFunName });
          _this3.__provideModalFun({ pageLogic: pageLogic });
        }
      });
    }
  }, {
    key: '_provideModalPageLogicForEvent',
    value: function _provideModalPageLogicForEvent(event) {
      this.logger.log('_providePageLogic(event)  event:', event);

      var funName = event.payload.target;
      var funParams = event.payload.funParams;

      return this._provideModalPageLogic({ funName: funName, funParams: funParams });
    }
  }, {
    key: '_provideModalPageLogic',
    value: function _provideModalPageLogic(spec) {
      return this.feconIsacFacade.pageLogic({
        funName: spec.funName,
        funParams: spec.funParams,
        mode: 'modal',
        flowName: 'modalLoginFlow',
        options: _lodash2.default.merge({}, spec.options, {
          additionalStyleClass: (spec.options && spec.options.additionalStyleClass || '') + ' modal-login-flow'
        })
      });
    }

    // ------

  }, {
    key: '_debugEnabled',
    value: function _debugEnabled(enabled) {
      if (!_lodash2.default.isUndefined(enabled)) {
        debugEnabled = !!enabled;
      }
      return debugEnabled;
    }
  }]);

  return FeconIsacModalLoginFlow;
}();

// utils

/**
 * Patch del metodo handleRedirect() di una isacPageLogic
 *
 * @param pageLogic {isacPageLogic} oggetto isacPageLogic da patchare
 * @param handleRedirectDelegateFn {Function} funzione delegata che viene invocata con i parametri event ed originalHandlerFn
 * @return {isacPageLogic}
 */


exports.default = FeconIsacModalLoginFlow;
function $pageLogicRedirectHandlerDecorator(pageLogic, handleRedirectDelegateFn) {
  var $handleRedirect = pageLogic.handleRedirect;

  pageLogic.handleRedirect = function _modalFlow$handleRedirect(event) {
    var originalHandlerFn = function originalHandlerFn(event) {
      return $handleRedirect.call(pageLogic, event);
    };
    return handleRedirectDelegateFn(event, originalHandlerFn);
  };

  return pageLogic;
}
module.exports = exports['default'];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _feconIsacFrame = __webpack_require__(7);

var _feconIsacFrame2 = _interopRequireDefault(_feconIsacFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isacFrameComponent = {
  bindings: {
    'isacPage': '<',
    'onRedirectRequired': '&'
  },
  controller: _feconIsacFrame2.default,
  template: __webpack_require__(19)
};

exports.default = isacFrameComponent;
module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeconIsacFrameController = function () {
  FeconIsacFrameController.$inject = ["$rootScope", "FeconIsacFacade", "$q", "iceSafeApply", "$timeout", "$log"];
  function FeconIsacFrameController($rootScope, FeconIsacFacade, $q, iceSafeApply, $timeout, $log) {
    'ngInject';

    _classCallCheck(this, FeconIsacFrameController);

    this.logger = $log.getInstance('FeconIsacFrameController');

    this._$rootScope = $rootScope;
    this._FeconIsacFacade = FeconIsacFacade;
    this.$q = $q;
    this.iceSafeApply = iceSafeApply;
    this.$timeout = $timeout;
  }

  _createClass(FeconIsacFrameController, [{
    key: '$onInit',
    value: function $onInit() {
      this.logger.debug('$onInit');

      this._unregisterBoundupdateIsacLanguage = this._$rootScope.$on('$translateChangeSuccess', this.updateIsacLanguage.bind(this));
    }
  }, {
    key: 'updateIsacLanguage',
    value: function updateIsacLanguage() {
      this.logger.log('updateIsacLanguage()');
      if (this._frameInterface && this._frameInterface.updateIsacLanguage) {
        this._frameInterface.updateIsacLanguage(this._FeconIsacFacade.getCurrentCompatibleIsacLanguage());
      }
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      this.logger.debug('$onDestroy');
      this.frameConfig = null; // help cleaup
      this._unregisterBoundupdateIsacLanguage();
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changes) {
      if (changes.isacPage) {
        this.logger.log('isacPage changed: ', this.isacPage);
        this._configureIsacPage();
      }
    }
  }, {
    key: '_configureIsacPage',
    value: function _configureIsacPage() {
      if (!this.isacPage) {
        this.logger.error('_configureIsacPage() - isacPage not provided.');
        this.frameConfig = null;
        return;
      }

      var isacPage = _lodash2.default.cloneDeep(this.isacPage);
      isacPage.funParams = isacPage.funParams || {};

      this.frameConfig = {
        pageName: isacPage.funName,
        htmlContent: getHtmlPage({
          isacInjectionFileName: isacPage.injection,
          parentRedirectHandlerFnName: '__feconParentMessageEventHandler',
          customizationObject: isacPage.customizationObject || {},
          forceEmail_options: {
            isApiCallDelegatedToProduct: isacPage.forceEmail_options.isApiCallDelegatedToProduct,
            apiPath: isacPage.forceEmail_options.apiPath
          },
          queryParam_OTP: isacPage.funParams.queryParam_OTP
        })
      };

      this.logger.debug('frameConfig: ', this.frameConfig);
    }

    /**
     * Called by IFrameElementDirective to expose its internal accessors
     * @param frameInterface {{ contentChanged: function, updateIsacLanguage: function }}
     * @private
     */

  }, {
    key: '__register_frame_interface',
    value: function __register_frame_interface(frameInterface) {
      this.logger.log('__register_frame_interface()');

      this._frameInterface = frameInterface;
    }

    /**
     * Called by IFrameElementDirective to notify that iFrame element is configured and ready to be displayed
     * @private
     */

  }, {
    key: '_onIFrameReady',
    value: function _onIFrameReady() {
      this.logger.log('_onIFrameReady()');
      if (this.frameConfig) {
        this.frameConfig.ready = true;
      } else {
        console.error('_onIFrameReady() called but this.frameConfig not exists! \n -> This is a bug, please report it to the InfoCert dev team.');
      }
    }
  }, {
    key: '_onIFrameRedirectRequested',
    value: function _onIFrameRedirectRequested(event) {
      var _this = this;

      this.logger.log('_onIFrameRedirectRequested() event:', event);

      switch (event.payload.target) {
        case '_feconCustom_execute_forceEmail':
          this.logger.log('_onIFrameRedirectRequested() case _feconCustom_execute_forceEmail - using a promise ..');
          return this._FeconIsacFacade.asyncExecuteSendEmailForCredentialsRecovery(event);
      }

      this.iceSafeApply(function () {
        // uso safeApply perché la direttiva invoca questa funzione fuori da angular e mi serve effettuare un digest
        _this.onRedirectRequired({ event: event });
      });
    }
  }]);

  return FeconIsacFrameController;
}();

exports.default = FeconIsacFrameController;


function getHtmlPage(pageSpec) {
  var isacInjectionFileName = pageSpec.isacInjectionFileName,
      parentRedirectHandlerFnName = pageSpec.parentRedirectHandlerFnName,
      customizationObject = pageSpec.customizationObject,
      forceEmail_options = pageSpec.forceEmail_options,
      queryParam_OTP = pageSpec.queryParam_OTP;


  if (_lodash2.default.isObject(customizationObject)) {
    customizationObject = JSON.stringify(customizationObject);
  }

  var forceEmail_isApiCallDelegatedToProduct = forceEmail_options.isApiCallDelegatedToProduct,
      forceEmail_apiPath = forceEmail_options.apiPath;

  // nel caso in cui venga ri-generata la isacPage (ad esempio la handleRedirect() restituisce { newIsacPage }), il timestamp variabile mi aiuta a scatenare l'onChange dell'html prodotto
  var generationTimestamp = _lodash2.default.now();

  return '<!DOCTYPE html>\n<html lang="en">\n<head>\n    <!-- generation: ' + generationTimestamp + ' -->\n    <meta charset="UTF-8">\n    <title>ISAC Page</title>\n    \n    <script>\n      var methods = (\'assert,clear,count,debug,dir,dirxml,error,exception,group,\' +\n      \'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,\' +\n      \'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn\').split(\',\');\n    \n      (function (window, methods) {\n        window.console = window.console || {};        \n        var feconIsacLogger = window._feconIsacLogger = {};\n        for (var i = 0; i < methods.length; i++) {\n          (function (prop) {\n            if(!console[prop]) console[prop] = function empty() {};\n            else {\n              var originalMethod = console[prop];\n              feconIsacLogger[prop] = function() {\n                var args = [].slice.call(arguments);\n                args.unshift(\'[fecon-isac-frame-content :\'+prop+\']\');\n                Function.prototype.bind\n                  .call(originalMethod, window.console)\n                  .apply(window.console, args);\n              };\n            }\n          })(methods[i]);\n        }\n      })(window, methods);\n    \n      (function (window, methods) {\n        window.console = window.console || {};        \n        var console = window.console;\n        for (var i = 0; i < methods.length; i++) {\n          (function (prop) {\n            if(!console[prop]) console[prop] = function empty() {};\n            else {\n              var originalMethod = console[prop];\n              console[prop] = function() {\n                var args = [].slice.call(arguments);\n                args.unshift(\'[isac-angular :\'+prop+\']\');\n                Function.prototype.bind\n                  .call(originalMethod, window.console)\n                  .apply(window.console, args);\n              };\n            }\n          })(methods[i]);\n        }\n      })(window, methods);\n    </script>\n\n    <script>\n      function _feconIsac_iFrame_unifiedRedirectFactory (target) {\n        return function _feconIsac_iFrame_unifiedRedirectHandler (param1, param2) {\n          var event = {\n            type: \'isacRedirect\',\n            data: {\n              target: target,\n              args: Array.prototype.slice.call(arguments)\n            }\n          };\n          \n          var parentRedirectHandler = \'' + parentRedirectHandlerFnName + '\';\n          window._feconIsacLogger.log(\'_feconIsac_iFrame_unifiedRedirectHandler() invoking parentRedirectHandler <as "\'+parentRedirectHandler+\'"> with event:\', event);\n          \n          if (window[parentRedirectHandler]) {\n            try {\n              var result = window[parentRedirectHandler](event);\n              window._feconIsacLogger.log(\'_feconIsac_iFrame_unifiedRedirectHandler() parentRedirectHandler() invocation <as "\'+parentRedirectHandler+\'"> result:\', result);\n              return result;\n            }\n            catch (e) {\n              window._feconIsacLogger.error(\'_feconIsac_iFrame_unifiedRedirectHandler() parentRedirectHandler() invocation <as "\'+parentRedirectHandler+\'"> throws error: \' + e.message + \'\\n\', e);\n            }\n          }\n          else {\n            window._feconIsacLogger.error(\'_feconIsac_iFrame_unifiedRedirectHandler() Expected parentRedirectHandler <as "\'+parentRedirectHandler+\'"> of type function but got \'+typeof parentRedirectHandler+\'. MISSED redirect handling, this is a bug.\');\n          }\n        }\n      } \n    </script>\n    \n    <script>\n      window.isacCustomization = ' + customizationObject + '; \n      window.isacCustomization.redirect = {\n        loggedIn: _feconIsac_iFrame_unifiedRedirectFactory(\'loggedIn\'),\n        pwForgot: _feconIsac_iFrame_unifiedRedirectFactory(\'pwForgot\'),\n        pwGone: _feconIsac_iFrame_unifiedRedirectFactory(\'pwGone\'), // window.location.href =  window.location.protocol + "//" + window.location.host + "?ln=" + data.user + "#/renew/password";\n        pwLock:  _feconIsac_iFrame_unifiedRedirectFactory(\'pwLock\'),\n        secInfo:  _feconIsac_iFrame_unifiedRedirectFactory(\'secInfo\'),\n        forceEmail: ' + (forceEmail_isApiCallDelegatedToProduct ? '_feconIsac_iFrame_unifiedRedirectFactory(\'_feconCustom_execute_forceEmail\')' : '\'' + forceEmail_apiPath + '\'') + (',\n        noInfoSec: _feconIsac_iFrame_unifiedRedirectFactory(\'noInfoSec\')\n      }\n    </script>\n\n\n    <link rel="stylesheet" href="/isac-angular/styles/main.css">\n    <script src="/isac-angular/scripts/injection/' + isacInjectionFileName + '"></script>\n    \n    <style>\n      html body {\n        margin: 0 !important;\n        padding: 0 !important;\n        overflow-y: hidden !important;\n        -ms-overflow-y: hidden !important;\n      }\n      html body .well {\n        border: none !important;\n        margin-bottom: 0;\n        -webkit-box-shadow: none;\n        box-shadow: none;\n      }\n      html body .panel {\n        border: none !important;\n        margin-left: -5px; // default: -15px\n        -webkit-box-shadow: none;\n        box-shadow: none;\n      }\n      body .modal {\n        overflow-y: visible;\n      }\n      a {\n          cursor: hand;\n          cursor: pointer;\n      }\n    </style>\n    \n</head>\n<body>\n  <div id="isacAngularModule" ng-app="isacApp">\n    <div id="isac-container" class="container" ng-view=""></div>\n  </div>\n\n  <script src="/isac-angular/scripts/vendor.js"></script>\n  <script src="/isac-angular/scripts/scripts.js?1"></script>\n\n  <!-- Decoratore per injection_force.js -> link ricevuto per email qParam OTP per reimpostare la password  -->\n  <script>\n    // decoratore UtilService.querystring per passare il parametro otp\n    angular\n      .module(\'isacApp\')\n      .config([\'$provide\', function($provide) {\n  \n        $provide.decorator(\'UtilService\', [\n          \'$delegate\',\n          function feconIsacDecoratorOf_UtilService ($delegate) {\n  \n            var original_querystring = $delegate.querystring;\n            $delegate.querystring = function decorated_querystring (name) {\n              if (name == \'otp\') {\n                window._feconIsacLogger.log(\'decorated_querystring(\'+name+\')\');\n                return "' + queryParam_OTP + '";\n              }\n              return original_querystring.apply($delegate, arguments);\n            };\n  \n            return $delegate;\n          }\n        ]);\n    }]);\n  </script>\n</body>\n</html>');
}
module.exports = exports['default'];

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


feconIsacIFrameElementDirective.$inject = ["$log", "$timeout", "_"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = feconIsacIFrameElementDirective;
function feconIsacIFrameElementDirective($log, $timeout, _) {
  'ngInject';

  var logger = $log.getInstance('feconIsacIFrameElementDirective');

  var initialIFrameHeight = 50;

  var iFrameContainerClass = '';
  var iFrameClass = 'fecon-isac-iframe-element';

  var iFrameStyle = 'display: block; width: 100%; height: ' + initialIFrameHeight + 'px; border: 0; overflow-y: hidden';

  var uid = 0;

  return {
    require: '^^feconIsacFrame',
    scope: {
      htmlContent: '<'
    },
    link: link
  };

  function link(scope, elem, attrs, feconIsacFrameComponent) {
    logger.log('link() - feconIsacFrameComponent:', feconIsacFrameComponent);
    logger.log('link() - scope:', scope);

    var scopeDestroyed = false;
    var lastAttachedFrame = null;

    scope.$on('$destroy', function () {
      scopeDestroyed = true;
      if (lastAttachedFrame && lastAttachedFrame.destroy) {
        lastAttachedFrame.destroy();
        lastAttachedFrame = null;
      }
    });

    feconIsacFrameComponent.__register_frame_interface({
      contentChanged: contentChanged,
      updateIsacLanguage: function updateIsacLanguage(language) {
        if (lastAttachedFrame && lastAttachedFrame.updateIsacLanguage) {
          lastAttachedFrame.updateIsacLanguage(language);
        }
      }
    });

    scope.$watch(function () {
      return scope.htmlContent;
    }, contentChanged);

    function iFrameReadyCallback() {
      feconIsacFrameComponent._onIFrameReady();
    }

    function contentChanged(htmlContent) {
      console.log('contentChanged()! length:' + (_.isString(htmlContent) && htmlContent.length) || 0);

      if (lastAttachedFrame && lastAttachedFrame.destroy) {
        lastAttachedFrame.destroy();
        lastAttachedFrame = null;
      }

      if (_.isString(htmlContent) && htmlContent.length > 0) {
        var messageEventHandler = function messageEventHandler(rawEvent) {

          if (!rawEvent || !rawEvent.type) {
            logger.warn('IGNORED raw event without attribute "name":', rawEvent);
            return;
          }

          switch (rawEvent.type) {
            case 'isacRedirect':
              logger.log('messageEventHandler(): rawEvent "' + rawEvent.type + "' - data: ", rawEvent.data);
              var type = rawEvent.type;
              var target = rawEvent.data.target;
              var params = rawEvent.data.args && rawEvent.data.args[0] || {};

              var event = {
                type: type,
                payload: {
                  target: target,
                  params: params
                }
              };
              logger.log('messageEventHandler(): event:', event);

              return feconIsacFrameComponent._onIFrameRedirectRequested(event);
              break;

            default:
              logger.log('messageEventHandler(): unhandled event name "' + event.name + "'.");
              break;
          }
        };

        logger.log('new attachIframe()');

        lastAttachedFrame = attachIframe(elem, htmlContent, messageEventHandler, scopeDestroyedAccessor, iFrameReadyCallback);
      } else {
        console.log('new content is empty. prevented attaching iFrame.');
      }
    }

    function scopeDestroyedAccessor() {
      return !!scopeDestroyed;
    }
  }

  function attachIframe(element, htmlContent, messageEventHandler, scopeDestroyedAccessor, onIFrameReadyCallback) {
    //console.info("attachIframe htmlContent:", htmlContent);

    var returnObject = {};

    if (!_.isString(htmlContent)) {
      htmlContent = '';
    }

    uid += 1;
    var frameId = 'fecon-isac-frame-content-' + uid;
    var frame = '<div class="' + iFrameContainerClass + '" ng-non-bindable>' + '<iframe id="' + frameId + '" class="' + iFrameClass + '" style="' + iFrameStyle + '" src="javascript:false;"></iframe>' + '';
    logger.log('frameId: ' + frameId + ' - content:', frame);

    var adjustIFrameHeightIntervalMs = 500;
    var adjustIFrameHeightMinimumPxDifference = 0; // differenza minima necessaria a scaturire l'aggiornamento dell'altezza
    var adjustIFrameHeightExtraPxHeight = 12; // spazio extra da aggiungere rispetto all'altezza calcolata
    var adjustIFrameHeightInterval = null;

    logger.debug('linking #' + frameId);

    function destroy() {
      console.log('destroy() iFrame #' + frameId);
      window.clearInterval(adjustIFrameHeightInterval);
      element.children().remove();
    }

    returnObject.destroy = destroy;

    element.append(frame);

    $timeout(function () {
      var ifrm = document.getElementById(frameId);
      ifrm.style.height = initialIFrameHeight + "px";

      if (scopeDestroyedAccessor()) {
        return;
      }

      var $iFrame = $('#' + frameId);
      $iFrame.ready(function () {
        $timeout(function () {
          // senza un timeout (a parte in chrome che funziona bene) vedo comparire e subito dopo scomparire il contenuto
          if (scopeDestroyedAccessor() || !$iFrame) {
            return;
          }

          var $iFrameContents = void 0;
          try {
            $iFrameContents = $iFrame.contents();
          } catch (e) {
            console.warn('cannot access iFrame.contents(): iframe already detached?');
            return;
          }

          if (!$iFrame[0]) {
            console.warn('iFrame not exists.');
            return;
          }

          window.$iFrame = $iFrame;

          console.log('inietto il contenuto .. ' + htmlContent && htmlContent.length);
          var iframe = $iFrame[0];
          // @see https://stackoverflow.com/questions/10418644/creating-an-iframe-with-given-html-dynamically   (alternative: https://github.com/jugglinmike/srcdoc-polyfill)
          iframe.contentWindow.document.open();
          iframe.contentWindow.document.write(htmlContent);
          iframe.contentWindow.document.close();

          returnObject.updateIsacLanguage = function (key) {
            try {
              var event = new CustomEvent("changeIsacLanguage", { detail: { language: key } });
              iframe.contentWindow.dispatchEvent(event);
            } catch (e) {
              console.error('Error updating isac language', e.message, e.stack);
            }
          };

          try {
            $iFrame[0].contentWindow.__feconParentMessageEventHandler = messageEventHandler;
          } catch (e) {
            console.warn('error attaching messageEventHandler function into iFrame:', e);
            throw new Error('FAILED', e);
          }

          logger.debug('filled content of #' + frameId);

          $timeout(function () {
            attachSyncIFrameHeight(frameId);

            if (onIFrameReadyCallback) {
              onIFrameReadyCallback();
            }
          }, 50);
        }, 50);
      });
    });

    function attachSyncIFrameHeight(frameId) {
      console.log('attachMutationListeners() frameId:', frameId);
      try {
        executeSyncIFrameHeight();
        adjustIFrameHeightInterval = window.setInterval(executeSyncIFrameHeight, adjustIFrameHeightIntervalMs);
      } catch (e) {
        console.warn('attachSyncIframeHeight() error:', e);
      }
    }

    function executeSyncIFrameHeight() {
      try {
        setIframeHeight(frameId, adjustIFrameHeightMinimumPxDifference, adjustIFrameHeightExtraPxHeight);
      } catch (e) {
        console.warn('Unable to synk iframe height', e);
      }
    }

    return returnObject;
  }

  // @see http://www.dyn-web.com/tutorials/iframes/height/
  function getDocHeight(doc) {
    //let isOldIE = (navigator.userAgent.indexOf("MSIE") !== -1); // Detect IE10 and below

    // stackoverflow.com/questions/1145850/
    var body = doc.body,
        html = doc.documentElement;
    var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

    //console.log('## getDocHeight() ## height: '+height);
    return height;
  }

  function setIframeHeight(id, minimumPxDifference, extraPxHeight) {
    minimumPxDifference = minimumPxDifference || 0;

    var ifrm = document.getElementById(id);
    if (!ifrm) {
      console.log('setIframeHeight() skippend: iframe not found for id +' + id);
      return;
    }

    var doc = ifrm.contentDocument ? ifrm.contentDocument : ifrm.contentWindow.document;
    var newHeight = getDocHeight(doc);
    var oldHeight = ('' + ifrm.style.height).replace('px', '');
    if (newHeight != oldHeight) {
      if (!minimumPxDifference || newHeight - oldHeight + extraPxHeight > minimumPxDifference) {
        var targetHeight = newHeight + extraPxHeight;
        if (targetHeight != oldHeight) {
          console.log('setIframeHeight() height changed from ' + oldHeight + ' to ' + targetHeight);
          ifrm.style.height = targetHeight + "px";
        }
      }
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(22);

var _angular2 = _interopRequireDefault(_angular);

var _feconIsacFrame = __webpack_require__(6);

var _feconIsacFrame2 = _interopRequireDefault(_feconIsacFrame);

var _feconIsacIframeElement = __webpack_require__(8);

var _feconIsacIframeElement2 = _interopRequireDefault(_feconIsacIframeElement);

var _FeconIsacFacade = __webpack_require__(4);

var _FeconIsacFacade2 = _interopRequireDefault(_FeconIsacFacade);

var _feconIsacRestClient = __webpack_require__(11);

var _feconIsacRestClient2 = _interopRequireDefault(_feconIsacRestClient);

var _FeconIsacModalPage = __webpack_require__(13);

var _FeconIsacModalPage2 = _interopRequireDefault(_FeconIsacModalPage);

var _feconIsacPage = __webpack_require__(16);

var _feconIsacPage2 = _interopRequireDefault(_feconIsacPage);

var _feconIsacModalPage = __webpack_require__(14);

var _feconIsacModalPage2 = _interopRequireDefault(_feconIsacModalPage);

var _feconIsacConfig = __webpack_require__(3);

var _feconIsacConfig2 = _interopRequireDefault(_feconIsacConfig);

var _feconIsacSessionExpiredHttpInterceptor = __webpack_require__(10);

var _feconIsacSessionExpiredHttpInterceptor2 = _interopRequireDefault(_feconIsacSessionExpiredHttpInterceptor);

var _FeconIsacModalLoginFlow = __webpack_require__(5);

var _FeconIsacModalLoginFlow2 = _interopRequireDefault(_FeconIsacModalLoginFlow);

var _fixFeconClientBundlePreconditions = __webpack_require__(18);

var _fixFeconClientBundlePreconditions2 = _interopRequireDefault(_fixFeconClientBundlePreconditions);

var _feconIsacMainPreconditions = __webpack_require__(17);

var _feconIsacMainPreconditions2 = _interopRequireDefault(_feconIsacMainPreconditions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentModule = _angular2.default.module('infocert.fecon-isac', []).provider('feconIsacConfig', _feconIsacConfig2.default).service('FeconIsacFacade', _FeconIsacFacade2.default).service('FeconIsacModalLoginFlow', _FeconIsacModalLoginFlow2.default).service('FeconIsacRestClient', _feconIsacRestClient2.default).component('feconIsacPage', _feconIsacPage2.default).component('feconIsacModalPage', _feconIsacModalPage2.default).service('FeconIsacModalPage', _FeconIsacModalPage2.default).component('feconIsacFrame', _feconIsacFrame2.default).directive('feconIsacFrameElement', _feconIsacIframeElement2.default).factory('feconIsacSessionExpiredHttpInterceptor', _feconIsacSessionExpiredHttpInterceptor2.default).config(_fixFeconClientBundlePreconditions2.default).run(_feconIsacMainPreconditions2.default).config(function () {
  window.dispatchFeconIsacEvent = function (event, frameWindow) {
    event = event || { type: 'isacRedirect', data: { target: 'secInfo' } };
    frameWindow = frameWindow || $('.fecon-isac-iframe-element').last()[0].contentWindow;
    frameWindow.__feconParentMessageEventHandler(event);
  };
}).name;

exports.default = componentModule;
module.exports = exports['default'];

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


feconIsacSessionExpiredHttpInterceptorFactory.$inject = ["feconIsacConfig", "$injector", "$q", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = feconIsacSessionExpiredHttpInterceptorFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var EXCLUSION_HEADER_CONFIG_KEY = 'sessionExpiredHttpInterceptor.exclusionHeader';
var ADDITIONAL_EXCLUSION_HEADERS_CONFIG_KEY = 'sessionExpiredHttpInterceptor.additionalExclusionHeaders';

/**
 * Interceptor http per identificare lo stato di "sessione scaduta".
 *
 * Precondizioni:
 * - lo status-code http è 401
 * - tra gli header della richiesta http NON è presente nessuno degli exclusion-header configurati in feconIsacConfig
 *
 * Se le precondizioni sono soddisfatte, l'interceptor notifica lo stato di "sessione scaduta" invocando FeconIsacFacade.sessionExpired()
 *
 * @param feconIsacConfig
 * @param $injector
 * @param $q
 * @param $log
 * @returns {{responseError: responseError}}
 */
function feconIsacSessionExpiredHttpInterceptorFactory(feconIsacConfig, $injector, $q, $log) {
  'ngInject';

  var logger = $log.getInstance('feconIsacSessionExpiredHttpInterceptor');

  var FeconIsacFacade = void 0; // devo iniettarlo dopo perché a sua volta utilizza $http e genera dipendenza circolare
  function _assureInjection() {
    if (!FeconIsacFacade) {
      FeconIsacFacade = $injector.get('FeconIsacFacade');
    }
  }

  return {
    'responseError': function responseError(rejection) {

      //LOGGER.log('response Error Catched: ' + rejection.status);
      //LOGGER.log('response Error: ', rejection);

      if (rejection.status == 401) {
        var defaultExclusionHeader = feconIsacConfig.get(EXCLUSION_HEADER_CONFIG_KEY);
        var additionalExclusionHeaders = feconIsacConfig.get(ADDITIONAL_EXCLUSION_HEADERS_CONFIG_KEY) || [];
        var firstExclusionHeaderMatch = _getFirstExclusionHeaderMatchingRejection(rejection, [defaultExclusionHeader].concat(_toConsumableArray(additionalExclusionHeaders)));

        if (firstExclusionHeaderMatch) {
          logger.log('Skipped. Response rejection matches an exclusion header: ' + JSON.stringify(firstExclusionHeaderMatch));
        } else {
          logger.error("Caught 401: evaluated as session expired.");
          _assureInjection();
          FeconIsacFacade.sessionExpired();
        }
      }

      return $q.reject(rejection);
    }
  };
}

function _getFirstExclusionHeaderMatchingRejection(rejection, exclusionHeaders) {

  // check for first exclusion header matching the given rejection
  return _lodash2.default.find(exclusionHeaders, function (exclusionHeader) {
    var headerIsPresent = _lodash2.default.has(rejection.config.headers, exclusionHeader.name);
    if (!headerIsPresent) return false;

    // se non è richiesto un valore specifico per l'header OPPURE è richiesto e corrisponde: ho un match
    if (!_lodash2.default.has(exclusionHeader, 'value') || exclusionHeader.value == rejection.config.headers[exclusionHeader.name]) {
      return exclusionHeader.name;
    }
  });
}
module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var feconIsacRestClient = function () {
  feconIsacRestClient.$inject = ["$http", "$timeout", "$q", "$log"];
  function feconIsacRestClient($http, $timeout, $q, $log) {
    'ngInject';

    _classCallCheck(this, feconIsacRestClient);

    this.logger = $log.getInstance('feconIsacRestClient');
    this.$http = $http;
    this.$timeout = $timeout;
    this.$q = $q;
  }

  _createClass(feconIsacRestClient, [{
    key: '__getConfig',
    value: function __getConfig() {
      return {
        isacRestEndpoint: '/isac-rest/'
      };
    }
  }, {
    key: 'getSecurityInfo',
    value: function getSecurityInfo() {
      var _this = this,
          _arguments = arguments;

      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var additionalHeaders = opts.additionalHeaders || {};

      return this.$http({
        method: 'GET',
        url: this.__getConfig().isacRestEndpoint + 'account/securityinfo',
        params: {
          ts: new Date().getTime()
        },
        cache: false,
        headers: Object.assign({}, additionalHeaders)
      }).then(function (data /*, status, headers*/) {
        _this.logger.debug('getSecurityInfo OK result:', _arguments);
        return _this.$q.resolve(data);
      }, function (response) {
        _this.logger.error('getSecurityInfo KO result:', _arguments);
        return _this.$q.reject({ status: response.status, data: response.data });
      });
    }
  }, {
    key: 'logout',
    value: function logout() {
      var _this2 = this,
          _arguments2 = arguments;

      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var additionalHeaders = opts.additionalHeaders || {};

      return this.$http({
        method: 'DELETE',
        url: this.__getConfig().isacRestEndpoint + 'session',
        headers: Object.assign({}, additionalHeaders),
        cache: false
      }).then(function (data /*, status, headers*/) {
        _this2.logger.debug('logout OK result:', _arguments2);
        return _this2.$q.resolve(data);
      }, function (data, status /*, header*/) {
        _this2.logger.error('logout KO result:', _arguments2);
        return _this2.$q.reject({
          data: data.data,
          status: status
        });
      });
    }
  }, {
    key: 'isAuthenticated',
    value: function isAuthenticated() {
      var _this3 = this;

      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var additionalHeaders = opts.additionalHeaders || {};

      // getSecurityInfo is actually used
      return this.getSecurityInfo({ additionalHeaders: additionalHeaders }).then(function () {
        return _this3.$q.resolve();
      }, function (e) {
        _this3.logger.log('checkAuthentication() (using isac.getSecurityInfo) -> error:', e);
        switch (e.status) {
          case 402:
            // OK: autenticato ma mancano le info sicurezza. questo servizio lo usiamo per sapere se siamo autenticati quindi è OK
            return _this3.$q.resolve();

          default:
            return _this3.$q.reject();
        }
      });
    }
  }]);

  return feconIsacRestClient;
}();

exports.default = feconIsacRestClient;
module.exports = exports['default'];

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeconIsacModalPageController = function () {
  FeconIsacModalPageController.$inject = ["$q", "$timeout", "$log"];
  function FeconIsacModalPageController($q, $timeout, $log) {
    'ngInject';

    _classCallCheck(this, FeconIsacModalPageController);

    this.logger = $log.getInstance('FeconIsacModalPageController');

    /**
     * @var close :component-input-binding injected by $uibModal
     */
    this.close = null;

    /**
     * @var dismiss :component-input-binding injected by $uibModal
     */
    this.dismiss = null;

    /**
     * @var resolve :component-input-binding expected isacPageLogic from $uibModal.resolve
     */
    this.resolve = null;

    this.$q = $q;
    this.$timeout = $timeout;
  }

  _createClass(FeconIsacModalPageController, [{
    key: '$onInit',
    value: function $onInit() {
      this.logger.debug('$onInit');

      this.isacPageLogic = this.resolve.isacPageLogic; // resolve injected by $uibModal.resolve
      if (!this.isacPageLogic) {
        this.logger.error('Expected isacPageLogic provided by $uibModal resolve mechanics!');
      }

      this.isacPage = this.isacPageLogic.getIsacPage();
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      this.logger.debug('$onDestroy');
      this.frameConfig = null; // help cleanup
    }
  }, {
    key: 'onRedirectRequired',
    value: function onRedirectRequired(event) {
      var _this = this;

      this.logger.log('onRedirectRequired() event:', event);

      var redirectLogicResult = this.isacPageLogic.handleRedirect(event);
      if (redirectLogicResult && redirectLogicResult.newIsacPage) {
        var newIsacPage = redirectLogicResult.newIsacPage;
        this.logger.debug('onRedirectRequired() isacPageLogic provided new isacPage:', newIsacPage);
        this.isacPage = newIsacPage;
      } else if (redirectLogicResult && redirectLogicResult.waitBeforeExit) {
        this.isWaitingBeforeExit = true;
        redirectLogicResult.waitBeforeExit.finally(function () {
          _this.close();
        });
      } else {
        this.logger.debug('onRedirectRequired() isacPageLogic provided nothing. -> Closing modal ..');
        return this.close();
      }
    }
  }]);

  return FeconIsacModalPageController;
}();

exports.default = FeconIsacModalPageController;
module.exports = exports['default'];

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeconIsacModalPage = function () {
  FeconIsacModalPage.$inject = ["$uibModal", "$log", "$q"];
  function FeconIsacModalPage($uibModal, $log, $q) {
    'ngInject';

    _classCallCheck(this, FeconIsacModalPage);

    this.logger = $log.getInstance('FeconIsacModalPage');
    this.$uibModal = $uibModal;
    this.$q = $q;
  }

  _createClass(FeconIsacModalPage, [{
    key: 'open',
    value: function open(opts) {
      opts = opts || {};

      if (!_.isObject(opts.isacPageLogic) || !_.isFunction(opts.isacPageLogic.getIsacPage) || !_.isFunction(opts.isacPageLogic.handleRedirect)) {
        return this.$q.reject(new Error('Invalid isacPageLogic object: ', opts.isacPageLogic));
      }

      this.logger.log('Opening .. ');

      var modalInstance = this.$uibModal.open({
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        component: 'feconIsacModalPage',
        resolve: {
          isacPageLogic: function isacPageLogic() {
            return opts.isacPageLogic;
          }
        }
      });

      return modalInstance.result;
    }
  }]);

  return FeconIsacModalPage;
}();

exports.default = FeconIsacModalPage;
module.exports = exports['default'];

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FeconIsacModalPage = __webpack_require__(12);

var _FeconIsacModalPage2 = _interopRequireDefault(_FeconIsacModalPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isacFrameComponent = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: _FeconIsacModalPage2.default,
  template: __webpack_require__(20)
};

exports.default = isacFrameComponent;
module.exports = exports['default'];

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeconIsacPageController = function () {
  FeconIsacPageController.$inject = ["$log"];
  function FeconIsacPageController($log) {
    'ngInject';

    /**
     * @param isacPageLogic :component-input-binding
     */

    _classCallCheck(this, FeconIsacPageController);

    this.isacPageLogic = null;
    this.logger = $log.getInstance('FeconIsacPageController');
  }

  _createClass(FeconIsacPageController, [{
    key: '$onInit',
    value: function $onInit() {
      this.logger.debug('$onInit', this);

      this.isacPage = this.isacPageLogic.getIsacPage();
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      this.logger.debug('$onDestroy');
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changes) {
      this.logger.debug('$onChanges', changes);
    }
  }, {
    key: 'onRedirectRequired',
    value: function onRedirectRequired(event) {
      this.logger.debug('onRedirectRequired() event:', event);

      var redirectLogicResult = this.isacPageLogic.handleRedirect(event);
      if (redirectLogicResult && redirectLogicResult.newIsacPage) {
        var newIsacPage = redirectLogicResult.newIsacPage;
        this.logger.debug('onRedirectRequired() isacPageLogic provided new isacPage:', newIsacPage);
        this.isacPage = newIsacPage;
      } else {
        this.logger.debug('onRedirectRequired() isacPageLogic provided nothing.');
      }
    }
  }]);

  return FeconIsacPageController;
}();

exports.default = FeconIsacPageController;
module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FeconIsacPage = __webpack_require__(15);

var _FeconIsacPage2 = _interopRequireDefault(_FeconIsacPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var feconIsacPageComponent = {
  bindings: {
    isacPageLogic: '<'
  },
  controller: _FeconIsacPage2.default,
  template: __webpack_require__(21)
};

exports.default = feconIsacPageComponent;
module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


feconIsacMainPreconditionsRunFn.$inject = ["$transitions", "$state", "$timeout", "feconIsacConfig", "FeconIsacFacade", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = feconIsacMainPreconditionsRunFn;

function feconIsacMainPreconditionsRunFn($transitions, $state, $timeout, feconIsacConfig, FeconIsacFacade, $log) {
  'ngInject';

  var logger = $log.getInstance('feconIsacMainPreconditions');

  function _getAuthRequired_stateDataPropertyName() {
    return feconIsacConfig.get('authenticationRequired.stateDataPropertyName') || 'authRequired';
  }

  $transitions.onError({}, function (transition) {
    logger.error('Transition error', arguments);
  });

  // TODO check: onBefore è già usato dalle fecon-preconditions
  // TODO -> l'ideale è accodarmi alle precondizioni altrimenti questa viene eseguita in parallelo
  // TODO    si può fare in 2 modi:
  // TODO      1. agganciandosi alle precondizioni fecon (vedere come)
  // TODO      2. usando onStart che viene eseguita DOPO onBefore (check: ha impatti di performance sul lifecycle ui-router?)
  $transitions.onStart({}, function (transition) {
    var stateService = transition.router.stateService;
    var authRequired = (transition.to().data || {})[_getAuthRequired_stateDataPropertyName()];

    if (authRequired) {
      logger.log('auth required for target state ' + transition.to().name);

      if (FeconIsacFacade.syncProductIsAuthenticated()) {
        logger.log('[OK: already authenticated (sync)]');

        logger.log('[checking SecurityInfo presence (sync)');
        if (FeconIsacFacade.syncHasSecurityInfo()) {
          logger.log('[OK: SecurityInfo present (sync)]');
          return true;
        } else {
          logger.log('[checking SecurityInfo presence (async) ..');
          return FeconIsacFacade.asyncCheckSecurityInfo().then(function () {
            logger.log('[checking SecurityInfo presence (async) .. => OK]');
            return true;
          }, function (e) {
            logger.error('[checking SecurityInfo presence (async) .. => ERROR]', e);
            //return stateService.target('setSecurityInfo');
            FeconIsacFacade.provideSecurityInfo();
            return false;
          });
        }

        // logger.log('[checking SecurityInfo presence (async) ..');
        // return FeconIsacFacade
        //   .asyncCheckSecurityInfo()
        //   .then(() => {
        //     logger.log('[checking SecurityInfo presence (async) .. => OK]');
        //     return true;
        //   }, (e) => {
        //     logger.error('[checking SecurityInfo presence (async) .. => ERROR]', e);
        //     //return stateService.target('setSecurityInfo');
        //     FeconIsacFacade.provideSecurityInfo();
        //     return false;
        //   });
      } else {
        logger.log('[checking product authenticated (async) ..]');
        return FeconIsacFacade.asyncCheckAuthentication().then(function () {
          logger.log('[checking product authenticated (async) .. => OK]');

          logger.log('[checking SecurityInfo presence (sync)');
          if (FeconIsacFacade.syncHasSecurityInfo()) {
            logger.log('[OK: SecurityInfo present (sync)]');
            return true;
          } else {
            logger.log('[checking SecurityInfo presence (async) ..');
            return FeconIsacFacade.asyncCheckSecurityInfo().then(function () {
              logger.log('[checking SecurityInfo presence (async) .. => OK]');
              return true;
            }, function (e) {
              logger.error('[checking SecurityInfo presence (async) .. => ERROR]', e);
              //return stateService.target('setSecurityInfo');
              FeconIsacFacade.provideSecurityInfo();
              return false;
            });
          }
        }, function (e) {
          logger.error('[checking product authenticated (async) .. => ERROR]', e);
          return FeconIsacFacade.provideAuthentication({
            initiator: 'fecon-isac.main-precondition',
            transition: transition
          });
        });
      }
    }
  });
}
module.exports = exports['default'];

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default =

/**
 * Rimuove la precondition authenticationProtector.stateChangePrecondition
 */
["applicationTransitionStateChangePreconditions", function (applicationTransitionStateChangePreconditions) {
  'ngInject';

  _lodash2.default.pull(applicationTransitionStateChangePreconditions, 'authenticationProtector.stateChangePrecondition');
}];

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = "<div class=\"\" ice-block-ui=\"!$ctrl.frameConfig.ready\">\n  <div fecon-isac-frame-element=\"\" html-content=\"$ctrl.frameConfig.htmlContent\" class=\"fecon-isac-iframe\" ng-if=\"$ctrl.frameConfig\"></div>\n</div>\n"

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fecon-isac-modal-page\" ice-block-ui=\"$ctrl.isWaitingBeforeExit\" ng-class=\"'fecon-isac-fun-' + $ctrl.isacPage.funName + ' ' + $ctrl.isacPage.options.additionalStyleClass\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-if=\"$ctrl.isacPage.options.userCanSkip\" ng-click=\"$ctrl.dismiss()\"><span aria-hidden=\"true\" ice-application-icon icon-name=\"icon.fecon.actions.close\"></span></button>\n    <h4 class=\"modal-title\">{{ $ctrl.isacPage.funTitle | translate }}</h4>\n  </div>\n\n  <div ng-if=\"$ctrl.isacPage.options.debug\" class=\"fecon-isac-modal-page__debug\">{{ $ctrl.isacPage | json }}</div>\n\n  <div class=\"modal-body\">\n    <fecon-isac-frame\n      isac-page=\"$ctrl.isacPage\"\n      on-redirect-required=\"$ctrl.onRedirectRequired(event)\"\n    ></fecon-isac-frame>\n    <div class=\"clearfix\"></div>\n  </div>\n  <div class=\"modal-footer\">&nbsp;</div>\n</div>\n"

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"fecon-isac-page\" ng-class=\"'fecon-isac-fun-' + $ctrl.isacPage.funName + ' ' + $ctrl.isacPage.options.additionalStyleClass\">\n  <div class=\"fecon-isac-page__container\">\n\n    <div ng-if=\"$ctrl.isacPage.options.debug\" class=\"fecon-isac-page__debug\">{{ $ctrl.isacPage | json }}</div>\n\n    <fecon-isac-frame\n      isac-page=\"$ctrl.isacPage\"\n      on-redirect-required=\"$ctrl.onRedirectRequired(event)\"\n    ></fecon-isac-frame>\n  </div>\n</div>\n"

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_22__;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_23__;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_24__;

/***/ })
/******/ ]);
});
//# sourceMappingURL=fecon-isac.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@infocert/fecon-isac/dist/@infocert/fecon-isac.js
// module id = 396
// module chunks = 0